import React from "react";
import { useFieldArray } from "react-hook-form";

/* -------------------- Experience Section -------------------- */
export function ExperienceFields({
  control,
  register,
  errors,
  field,
  index,
  removeExp,
}) {
  const {
    fields: responsibilityFields,
    append: addResponsibility,
    remove: removeResponsibility,
  } = useFieldArray({
    control,
    name: `work_experience.${index}.responsibilities`,
  });

  return (
    <div className="u_edit_exp">
      <div key={field.id} className="border rounded p-3 mb-3 u_edit_relative">
        <div className="row g-2">
          {/* Job title */}
          <div className="col-md-6">
            <input
              {...register(`work_experience.${index}.job_title`, {
                required: "Job Title is required",
              })}
              className="input"
              placeholder="Job Title *"
            />
            {errors.work_experience?.[index]?.job_title && (
              <span className="text-danger small">
                {errors.work_experience[index].job_title.message}
              </span>
            )}
          </div>

          {/* Company */}
          <div className="col-md-6">
            <input
              {...register(`work_experience.${index}.company`, {
                required: "Company is required",
              })}
              className="input"
              placeholder="Company *"
            />
            {errors.work_experience?.[index]?.company && (
              <span className="text-danger small">
                {errors.work_experience[index].company.message}
              </span>
            )}
          </div>

          {/* Location */}
          <div className="col-md-6">
            <input
              {...register(`work_experience.${index}.location`, {
                required: "Location is required",
              })}
              className="input"
              placeholder="Location *"
            />
            {errors.work_experience?.[index]?.location && (
              <span className="text-danger small">
                {errors.work_experience[index].location.message}
              </span>
            )}
          </div>

          {/* Dates */}
          <div className="col-md-3">
            <input
              {...register(`work_experience.${index}.start_date`, {
                required: "Start Date is required",
              })}
              className="input"
              placeholder="Start Date *"
            />
          </div>
          <div className="col-md-3">
            <input
              {...register(`work_experience.${index}.end_date`, {
                required: "End Date is required",
              })}
              className="input"
              placeholder="End Date *"
            />
          </div>

          {/* Responsibilities section */}
          <div className="col-12">
            <h6 className="fw-bold u_edit_h6">Responsibilities</h6>
            {responsibilityFields.map((rField, rIndex) => (
              <div
                key={rField.id}
                className="d-flex gap-2 mb-4 align-items-center u_edit_cross"
              >
                <div className="flex-grow-1">
                  <textarea
                    {...register(
                      `work_experience.${index}.responsibilities.${rIndex}`,
                      { required: "Responsibility is required" }
                    )}
                    className="input"
                    rows="2"
                    placeholder={`Responsibility ${rIndex + 1} *`}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => removeResponsibility(rIndex)}
                >
                  X
                </button>
              </div>
            ))}

            <button
              type="button"
              className="btn btn-outline-primary btn-lg "
              onClick={() => addResponsibility("")}
            >
              + Add Responsibility
            </button>
          </div>
        </div>

        <button
          type="button"
          className="btn btn-danger btn-md mt-2 btn-danger1"
          onClick={() => removeExp(index)}
        >
          x
        </button>
      </div>
    </div>
  );
}

/* -------------------- Project Section -------------------- */
export function ProjectFields({
  control,
  register,
  errors,
  field,
  index,
  removeProject,
}) {
  const {
    fields: bulletFields,
    append: addBullet,
    remove: removeBullet,
  } = useFieldArray({
    control,
    name: `projects.${index}.bullets`,
  });

  return (
    <div className="_uj_space">
      <div key={field.id} className="border rounded p-3 mb-3 u_edit_relative">
        <div className="row g-2">
          {/* Project Name */}
          <div className="col-md-6">
            <input
              {...register(`projects.${index}.project_name`, {
                required: "Project Name is required",
              })}
              className="input"
              placeholder="Project Name *"
            />
            {errors.projects?.[index]?.project_name && (
              <span className="text-danger small">
                {errors.projects[index].project_name.message}
              </span>
            )}
          </div>

          {/* Organization */}
          <div className="col-md-6">
            <input
              {...register(`projects.${index}.organization`, {
                required: "Organization is required",
              })}
              className="input"
              placeholder="Organization *"
            />
            {errors.projects?.[index]?.organization && (
              <span className="text-danger small">
                {errors.projects[index].organization.message}
              </span>
            )}
          </div>

          {/* Location */}
          <div className="col-md-6">
            <input
              {...register(`projects.${index}.location`, {
                required: "Location is required",
              })}
              className="input"
              placeholder="Location *"
            />
            {errors.projects?.[index]?.location && (
              <span className="text-danger small">
                {errors.projects[index].location.message}
              </span>
            )}
          </div>

          {/* Dates */}
          <div className="col-md-3">
            <input
              {...register(`projects.${index}.start_date`, {
                required: "Start Date is required",
              })}
              className="input"
              placeholder="Start Date *"
            />
          </div>

          <div className="col-md-3">
            <input
              {...register(`projects.${index}.end_date`, {
                required: "End Date is required",
              })}
              className="input"
              placeholder="End Date *"
            />
          </div>

          {/* Bullets Section */}
          <div className="col-12">
            <h6 className="fw-bold mt-2">Bullets</h6>

            {bulletFields.map((bField, bIndex) => (
              <div
                key={bField.id}
                className="d-flex gap-2 mb-2 align-items-center u_edit_cross"
              >
                <div className="flex-grow-1">
                  <textarea
                    {...register(`projects.${index}.bullets.${bIndex}`, {
                      required: "Bullet point is required",
                    })}
                    className="input"
                    rows="2"
                    placeholder={`Bullet ${bIndex + 1} *`}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => removeBullet(bIndex)}
                >
                  X
                </button>
              </div>
            ))}

            <button
              type="button"
              className="btn btn-outline-primary btn-lg mt-2"
              onClick={() => addBullet("")}
            >
              + Add Bullet Point
            </button>
          </div>
        </div>

        <button
          type="button"
          className="btn btn-danger btn-md mt-2 btn-danger1"
          onClick={() => removeProject(index)}
        >
          x
        </button>
      </div>
    </div>
  );
}

/* -------------------- Volunteering & Leadership Section -------------------- */
export function VolunteeringFields({
  control,
  register,
  errors,
  field,
  index,
  removeVolunteer,
}) {
  const {
    fields: bulletFields,
    append: addBullet,
    remove: removeBullet,
  } = useFieldArray({
    control,
    name: `volunteering.${index}.bullets`,
  });

  return (
    <div className="_uj_space">
      <div key={field.id} className="border rounded p-3 mb-3 u_edit_relative">
        <div className="row g-2">
          <div className="col-md-6">
            <input
              {...register(`volunteering.${index}.role_title`, {
                required: "Role or Title is required",
              })}
              className="input"
              placeholder="Role or Title *"
            />
            {errors.volunteering?.[index]?.role_title && (
              <span className="text-danger small">
                {errors.volunteering[index].role_title.message}
              </span>
            )}
          </div>

          <div className="col-md-6">
            <input
              {...register(`volunteering.${index}.organization`, {
                required: "Organization is required",
              })}
              className="input"
              placeholder="Organization *"
            />
            {errors.volunteering?.[index]?.organization && (
              <span className="text-danger small">
                {errors.volunteering[index].organization.message}
              </span>
            )}
          </div>

          <div className="col-md-6">
            <input
              {...register(`volunteering.${index}.location`, {
                required: "Location is required",
              })}
              className="input"
              placeholder="Location *"
            />
          </div>

          <div className="col-md-3">
            <input
              {...register(`volunteering.${index}.start_date`, {
                required: "Start Date is required",
              })}
              className="input"
              placeholder="Start Date *"
            />
          </div>

          <div className="col-md-3">
            <input
              {...register(`volunteering.${index}.end_date`, {
                required: "End Date is required",
              })}
              className="input"
              placeholder="End Date *"
            />
          </div>

          {/* Bullets */}
          <div className="col-12">
            <h6 className="fw-bold mt-2">Bullets</h6>
            {bulletFields.map((bField, bIndex) => (
              <div
                key={bField.id}
                className="d-flex gap-2 mb-2 align-items-center u_edit_cross"
              >
                <div className="flex-grow-1">
                  <textarea
                    {...register(`volunteering.${index}.bullets.${bIndex}`, {
                      required: "Bullet is required",
                    })}
                    className="input"
                    rows="2"
                    placeholder={`Bullet ${bIndex + 1} *`}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => removeBullet(bIndex)}
                >
                  X
                </button>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-outline-primary btn-lg mt-2"
              onClick={() => addBullet("")}
            >
              + Add Bullet Point
            </button>
          </div>
        </div>

        <button
          type="button"
          className="btn btn-danger btn-md mt-2 btn-danger1"
          onClick={() => removeVolunteer(index)}
        >
          x
        </button>
      </div>
    </div>
  );
}

/* -------------------- Publications Section -------------------- */
export function PublicationFields({
  register,
  errors,
  field,
  index,
  removePublication,
}) {
  return (
    <div className="_uj_space">
      <div key={field.id} className="border rounded p-3 mb-3 u_edit_relative ">
        <div className="row g-2">
          {/* Publication Title */}
          <div className="col-md-6">
            <input
              {...register(`publications.${index}.title`, {
                required: "Publication Title is required",
              })}
              className="input"
              placeholder="Publication Title *"
            />
            {errors.publications?.[index]?.title && (
              <span className="text-danger small">
                {errors.publications[index].title.message}
              </span>
            )}
          </div>

          {/* Publisher or Journal */}
          <div className="col-md-6">
            <input
              {...register(`publications.${index}.publisher`, {
                required: "Publisher or Journal is required",
              })}
              className="input"
              placeholder="Publisher or Journal *"
            />
            {errors.publications?.[index]?.publisher && (
              <span className="text-danger small">
                {errors.publications[index].publisher.message}
              </span>
            )}
          </div>

          {/* Details */}
          <div className="col-md-8">
            <textarea
              {...register(`publications.${index}.details`, {
                required: "Details are required",
              })}
              className="input"
              rows="3"
              placeholder="Details about the publication (e.g., abstract, link) *"
            />
            {errors.publications?.[index]?.details && (
              <span className="text-danger small">
                {errors.publications[index].details.message}
              </span>
            )}
          </div>

          {/* Date */}
          <div className="col-md-4">
            <input
              {...register(`publications.${index}.date`, {
                required: "Date is required",
              })}
              className="input"
              placeholder="Date *"
            />
            {errors.publications?.[index]?.date && (
              <span className="text-danger small">
                {errors.publications[index].date.message}
              </span>
            )}
          </div>
        </div>

        <button
          type="button"
          className="btn btn-danger btn-md mt-2 btn-danger1"
          onClick={() => removePublication(index)}
        >
          x
        </button>
      </div>
    </div>
  );
}

/* -------------------- Certification Section -------------------- */
export function CertificationFields({
  register,
  errors,
  field,
  index,
  removeCertification,
}) {
  return (
    <div className="_uj_space">
      <div key={field.id} className="border rounded p-3 mb-3 u_edit_relative ">
        <div className="row g-2">
          <div className="col-md-6">
            <input
              {...register(`certifications.${index}.name`, {
                required: "Certification Name is required",
              })}
              className="input"
              placeholder="Certification Name *"
            />
            {errors.certifications?.[index]?.name && (
              <span className="text-danger small">
                {errors.certifications[index].name.message}
              </span>
            )}
          </div>

          <div className="col-md-6">
            <input
              {...register(`certifications.${index}.organization`, {
                required: "Issuing Organization is required",
              })}
              className="input"
              placeholder="Issuing Organization *"
            />
            {errors.certifications?.[index]?.organization && (
              <span className="text-danger small">
                {errors.certifications[index].organization.message}
              </span>
            )}
          </div>

          <div className="col-md-8">
            <textarea
              {...register(`certifications.${index}.details`, {
                required: "Details are required",
              })}
              className="input"
              rows="3"
              placeholder="Details about the certification *"
            />
            {errors.certifications?.[index]?.details && (
              <span className="text-danger small">
                {errors.certifications[index].details.message}
              </span>
            )}
          </div>

          <div className="col-md-4">
            <input
              {...register(`certifications.${index}.date`, {
                required: "Date is required",
              })}
              className="input"
              placeholder="Date *"
            />
            {errors.certifications?.[index]?.date && (
              <span className="text-danger small">
                {errors.certifications[index].date.message}
              </span>
            )}
          </div>
        </div>

        <button
          type="button"
          className="btn btn-danger btn-md mt-2 btn-danger1"
          onClick={() => removeCertification(index)}
        >
          x
        </button>
      </div>
    </div>
  );
}

/* -------------------- Award Section -------------------- */
export function AwardFields({ register, errors, field, index, removeAward }) {
  return (
    <div className="_uj_space">
      <div key={field.id} className="border rounded p-3 mb-3 u_edit_relative ">
        <div className="row g-2">
          <div className="col-md-6">
            <input
              {...register(`awards.${index}.name`, {
                required: "Award Name is required",
              })}
              className="input"
              placeholder="Award or Honor Name *"
            />
            {errors.awards?.[index]?.name && (
              <span className="text-danger small">
                {errors.awards[index].name.message}
              </span>
            )}
          </div>

          <div className="col-md-6">
            <input
              {...register(`awards.${index}.awarded_by`, {
                required: "Awarded By is required",
              })}
              className="input"
              placeholder="Awarded By *"
            />
            {errors.awards?.[index]?.awarded_by && (
              <span className="text-danger small">
                {errors.awards[index].awarded_by.message}
              </span>
            )}
          </div>

          <div className="col-md-8">
            <textarea
              {...register(`awards.${index}.details`, {
                required: "Details are required",
              })}
              className="input"
              rows="3"
              placeholder="Details about the award *"
            />
            {errors.awards?.[index]?.details && (
              <span className="text-danger small">
                {errors.awards[index].details.message}
              </span>
            )}
          </div>

          <div className="col-md-4">
            <input
              {...register(`awards.${index}.date`, {
                required: "Date is required",
              })}
              className="input"
              placeholder="Date *"
            />
            {errors.awards?.[index]?.date && (
              <span className="text-danger small">
                {errors.awards[index].date.message}
              </span>
            )}
          </div>
        </div>

        <button
          type="button"
          className="btn btn-danger btn-md mt-2 btn-danger1"
          onClick={() => removeAward(index)}
        >
          x
        </button>
      </div>
    </div>
  );
}

/* -------------------- Hobby Section -------------------- */
export function HobbyFields({ register, errors, field, index, removeHobby }) {
  return (
    <div
      key={field.id}
      className="d-flex gap-2 mb-2 align-items-center u_edit_cross"
    >
      <div className="flex-grow-1">
        <input
          {...register(`hobbies.${index}.title`, {
            required: "Hobby or Interest is required",
          })}
          className="input"
          placeholder="Hobby or Interest *"
        />
        {errors.hobbies?.[index]?.title && (
          <span className="text-danger small">
            {errors.hobbies[index].title.message}
          </span>
        )}
      </div>

      <button
        type="button"
        className="btn btn-danger btn-sm"
        onClick={() => removeHobby(index)}
      >
        X
      </button>
    </div>
  );
}

/* -------------------- Right to Work Section -------------------- */
export function RightToWorkFields({
  register,
  errors,
  field,
  index,
  removeRight,
}) {
  return (
    <div
      key={field.id}
      className="d-flex gap-2 mb-2 align-items-center u_edit_cross"
    >
      <div className="flex-grow-1">
        <input
          {...register(`right_to_work.${index}.title`, {
            required: "Right to Work is required",
          })}
          className="input"
          placeholder="Right to Work *"
        />
        {errors.right_to_work?.[index]?.title && (
          <span className="text-danger small">
            {errors.right_to_work[index].title.message}
          </span>
        )}
      </div>

      <button
        type="button"
        className="btn btn-danger btn-sm"
        onClick={() => removeRight(index)}
      >
        X
      </button>
    </div>
  );
}
